var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-keyword"},[_c('div',{staticClass:"tooltip"},[_vm._v(_vm._s(_vm.keyword.type)+":"+_vm._s(_vm.keyword.value)),_c('span',{staticClass:"tooltiptext"},[_vm._v("Keyword")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }